import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate } from "../lib/api";

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);

  if (!data) return <p className="text-sub text-sm">Memuat…</p>;

  const stats = [
    { label: "Tulisan Terbit", value: data.articles_published ?? 0, testid: "dashboard-stat-published" },
    { label: "Draf & Terjadwal", value: data.articles_draft ?? 0, testid: "dashboard-stat-drafts" },
    { label: "Pesan Baru", value: data.messages_new ?? 0, testid: "dashboard-stat-messages" },
    { label: "Subscriber Aktif", value: data.subscribers_confirmed ?? 0, testid: "dashboard-stat-subscribers" },
    { label: "Karya Terbit", value: data.books_published ?? 0, testid: "dashboard-stat-books" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-serif text-3xl text-ink">Selamat datang, Heri</h1>
          <p className="text-sub text-sm mt-1">Ringkasan situs Anda hari ini.</p>
        </div>
        <Link to="/admin/tulisan/baru" data-testid="dashboard-new-article" className="btn-primary">Tulis Artikel Baru</Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-8">
        {stats.map((s) => (
          <div key={s.label} data-testid={s.testid} className="bg-surface border border-line rounded-lg p-5">
            <p className="font-serif text-3xl text-ink">{s.value}</p>
            <p className="text-[13px] text-sub mt-1">{s.label}</p>
          </div>
        ))}
      </div>

      {!data.email_active && (
        <div className="mt-6 bg-surface-muted border border-line rounded-lg p-5 text-sm text-sub leading-relaxed" data-testid="dashboard-email-status">
          <strong className="text-ink">Layanan email belum aktif.</strong> Newsletter dan notifikasi pesan akan tersimpan tetapi email belum terkirim. Aktifkan melalui Secrets lingkungan backend.
        </div>
      )}

      <div className="mt-10 bg-surface border border-line rounded-xl p-6">
        <h2 className="font-serif text-xl text-ink mb-4">Draf Terakhir</h2>
        {(data.recent_drafts || []).length === 0 ? (
          <p className="text-sub text-sm">Belum ada draf. Mulai dengan <Link to="/admin/tulisan/baru" className="text-enji underline">menulis artikel baru</Link>.</p>
        ) : (
          <ul className="divide-y divide-line">
            {data.recent_drafts.map((d) => (
              <li key={d.id}>
                <Link to={`/admin/tulisan/${d.id}`} data-testid={`dashboard-draft-${d.id}`} className="flex items-center justify-between gap-4 py-3 hover:opacity-80">
                  <span className="text-ink text-[15px] truncate">{d.title}</span>
                  <span className="text-[12px] text-faint whitespace-nowrap">{d.status} · {formatDate(d.updated_at)}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p className="text-[13px] text-faint mt-8 leading-relaxed">
        Tidak ada statistik kunjungan palsu di sini — hanya data nyata dari konten dan pesan Anda.
      </p>
    </div>
  );
}

